import { Component, Input, OnInit } from "@angular/core";
import { IdService } from "./../shared/services/id.service";

@Component({
	selector: "rbc-label",
	template: `
		<label
			*ngIf="text"
			[id]="id"
			[for]= "for ? for : id"
			class= "rbc-label"
			[ngClass]="{ 'sr-only': srOnly }"
		>
			{{ text }}<span *ngIf="required" class="rbc-label-asterisk">*</span>
		</label>
	`,
	styles: []
})
export class LabelComponent {
	@Input() srOnly: boolean;
	@Input() text: string;
	@Input() id: string;
	@Input() for: string;
	@Input() required: boolean;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}
}
